import { OnInit } from "@angular/core";
import { Field } from "../field";
export class SelectMultipleComponent extends Field {
    constructor() {
        super(...arguments);
        /**
         * Attributes
         */
        // Settings configuration
        this.OBJ_settings = {
            id: "id",
            text: "title",
            enableFilter: true,
            placeholder: "please_select",
            filterPlaceholder: "filter",
            multiple: false,
            options: null
        };
    }
    /**
     * Function > ngOnInit
     */
    ngOnInit() {
        this.OBJ_settings.multiple = (this.OBJ_field_config.multiple != null) ? this.OBJ_field_config.multiple : true;
        this.OBJ_settings.options = (this.OBJ_field_config._links.options != null) ? this.OBJ_field_config._links.options : null;
    } // end function ngOnInit
    /**
     * Function > isInvalid
     * @return {boolean}
     */
    isInvalid() {
        if (this.isRequired()) {
            return this.OBJ_data.ids.length === 0;
        } // end if
        return false;
    } // end function isInvalid
} // end class SelectMultipleComponent
